module.exports = __webpack_public_path__ + "static/media/delete_enable.383b00bf.svg";